import React, { useState } from "react";
import { Edit, NumberInput, SimpleForm, TextField, TextInput } from "react-admin";
import { Typography } from "@material-ui/core";
import { PublishEditAside, PublishEditToolbar } from "lib/components/PublishEdit";
import { getRequiredFieldErrors } from "../../utils";

export function ClassStyleEdit(props) {
  const [isFormDirty, setIsFormDirty] = useState(false);
  return (
    <Edit
      actions={false}
      {...props}
      mutationMode="pessimistic"
      aside={<PublishEditAside config={{ resource: "classStyles", resourceLabel: "Class Style" }} isFormDirty={isFormDirty} />}
    >
      <SimpleForm
        toolbar={<PublishEditToolbar setIsFormDirty={setIsFormDirty} />}
        validate={(v) => getRequiredFieldErrors(v, ["name"])}
        warnWhenUnsavedChanges
      >
        <Typography variant="h6">Edit Class Style</Typography>
        <TextField source="slug" label="Slug (immutable)" />
        <TextField source="classCount" label="# Classes using this style" />
        <TextInput source="name" fullWidth />
        <NumberInput source="sortIndex" step={1} min={0} />
      </SimpleForm>
    </Edit>
  );
}
